export function rating() {
    return {
      restrict: 'E',
      template: require('./rating.directive.html'),
      scope: {
        model: '=',
        placeholder: '@',
        readonly: '<',
        ratingOperatorItems: '=',
        condition: '='
      }
    };
  }